import React from "react";
import AppLogo from "../../assets/icons/logo.svg";
import { LoadingScreenFooter } from "../elements/footer";
import "./styles.css";

function Loading() {
  return (
    <div className="z-[2000] flex flex-col justify-between bg-white min-h-screen">
      <div className="flex flex-col items-center gap-14 mt-auto mb-auto font-poppins">
        <img src={AppLogo} alt="App Logo" width={160} />
        <div
          className="sk-folding-cube"
          style={{ "--cube-color-var": "#5038BC" }}
        >
          <div className="sk-cube1 sk-cube" />
          <div className="sk-cube2 sk-cube" />
          <div className="sk-cube4 sk-cube" />
          <div className="sk-cube3 sk-cube" />
        </div>
        <h3>Never miss a Bikun again</h3>
      </div>
      <LoadingScreenFooter />
    </div>
  );
}

export default Loading;
